import { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { fetchChannelView, fetchChannelBlocksByHandle } from '@ego/api';
import styles from './ChannelCard.module.css';


export default function ChannelCard({ channel }) {
  const prefetch = useCallback(() => {
    if (!channel.handle || !channel.slug) return;
    fetchChannelView(channel.handle, channel.slug).catch(() => {});
    fetchChannelBlocksByHandle(channel.handle, channel.slug).catch(() => {});
  }, [channel.handle, channel.slug]);
  const colorStyle = channel.accentColor
    ? { '--channel-accent': channel.accentColor, '--channel-border': channel.borderColor || channel.accentColor }
    : undefined;
  const channelPath = channel.handle ? `/${channel.handle}/${channel.slug}` : `/channels/${channel.slug}`;
  const isPasswordProtected = channel.visibility === 'password';
  const isHidden = channel.visibility === 'hidden';
  const hasPreviews = channel.previews.some(Boolean);
  const showLocked = isPasswordProtected && !hasPreviews;

  return (
    <Link to={channelPath} className={styles.cardLink} onMouseEnter={prefetch}>
    <article className={styles.card} style={colorStyle}>
      <div className={styles.label}>
        <div className={styles.labelContent}>
          <h3 className={styles.title}>{channel.title}</h3>
          {isPasswordProtected && <span className={styles.badge}>Locked</span>}
          {isHidden && <span className={styles.badge}>Hidden</span>}
          <p className={styles.author}>by {channel.author}</p>
          <p className={styles.blocks}>{channel.blocksCount} blocks</p>
          <p className={styles.updated}>{channel.updatedRelative}</p>
        </div>
      </div>
      <div className={styles.previews}>
        {showLocked
          ? [0, 1, 2].map(i => (
              <div key={i} className={`${styles.tile} ${styles.tileLocked}`} />
            ))
          : channel.previews.map((preview, i) => (
              <div key={i} className={styles.tile}>
                {!preview ? (
                  <div className={styles.tilePlaceholder} />
                ) : preview.imageUrl && !preview.imageUrl.toLowerCase().endsWith('.pdf') ? (
                  <img src={preview.imageUrl} alt="" className={styles.tileImg} loading="lazy" />
                ) : preview.type === 'text' || preview.type === 'link' ? (
                  <div className={styles.tileTextWrap}>
                    <div className={styles.tileText}>{preview.content}</div>
                  </div>
                ) : (
                  <div className={styles.tilePlaceholder} />
                )}
              </div>
            ))
        }
      </div>
    </article>
    </Link>
  );
}
